import { MyCardService } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { StatusChangeResult, StatusItemAction } from '@models/imported/SagaBase';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { StatusService } from '@services/status/status.service';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';

@Injectable({
  providedIn: 'root'
})
export class EngagementService {
  private canReassign: boolean = true;
  private enabledFor: string = '';

  constructor(private myUnitService: MyUnitService, private statusService: StatusService, private myCardService: MyCardService) {}

  setup(canReassign: boolean, enabledFor: string) {
    this.canReassign = canReassign;
    this.enabledFor = enabledFor;
  }

  engage(callcard: CallCard): Promise<StatusChangeResult> {
    const isRequestAssignment: ListResourceStatus = this.statusService.getStatusByAction(StatusItemAction.isRequestAssignment);
    const newStatusItemAction: StatusItemAction = this.myUnitService.isEngaged()
      ? StatusItemAction.isReassignment
      : isRequestAssignment !== null
      ? StatusItemAction.isRequestAssignment
      : StatusItemAction.isAssignement;

    const newStatus: ListResourceStatus = this.statusService.getStatusByAction(newStatusItemAction);
    return this.statusService.changeStatus(newStatus, callcard);
  }

  isEngageAllowedFor(callcard: CallCard): boolean {
    return (
      !!callcard &&
      (this.canReassign || !!!this.myCardService.myCard) &&
      callcard.ObjGuid != this.myCardService.myCardId &&
      (this.enabledFor == 'Preassigned' ? this.isPreassigned(callcard) : true)
    );
  }

  private isPreassigned(callcard: CallCard): boolean {
    return callcard.preattribution?.jsonData?.Status == 0 || false;
  }
}
